export const DEFAULT_SOURCE_CONFIG = { mode: 'empty', target_pct: 80 };

export const redistributionStateSchema = {
    allLocations: {
        type: 'array',
        default: [],
        items: { type: 'object' }
    },
    isLoadingAllLocations: {
        type: 'boolean',
        default: false
    },
    plan: {
        type: ['array', 'null'],
        default: null,
        items: { type: 'object' }
    },
    planId: {
        type: ['string', 'null'],
        default: null
    },
    planStatus: {
        type: ['string', 'null'],
        default: null
    },
    planStats: {
        type: ['object', 'null'],
        default: null
    },
    executeResult: {
        type: ['object', 'null'],
        default: null
    },
    isLoadingPlan: {
        type: 'boolean',
        default: false
    },
    isExecuting: {
        type: 'boolean',
        default: false
    },
    locationItems: {
        type: 'object',
        default: {}
    },
    sourcesConfig: {
        type: 'object',
        default: {}
    },
    destinationStats: {
        type: ['object', 'null'],
        default: null
    },
    sourceStats: {
        type: ['object', 'null'],
        default: null
    }
};
